/* eslint-disable @typescript-eslint/no-dynamic-delete */
import React, { memo, useRef, FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Input, Button } from '@ss/mtd-react';
import { urlParse } from '@block/utils';
import { useLocation } from 'react-router-dom';
import { PAGE_NO } from '@common/const';
import useGo from '@utils/navigate';
import { LxSiteClick } from '@utils/siteLx';
import { useRootStore } from '@src/model';
import './index.scss';

interface IProps {
  keywords?: string;
}
const SearchInput: FC<IProps> = observer(() => {
  const iptRef = useRef<any>(null);
  const location = useLocation();
  const pathname = location?.pathname;
  const { replace } = useGo();
  const { headerStore } = useRootStore();
  const { handleSearch } = headerStore;
  const urlQueryInfo = urlParse(location.search);
  let keywords = '';
  try {
    keywords = urlQueryInfo?.keyword ? decodeURIComponent(urlQueryInfo?.keyword) : '';
  } catch (e) {
    keywords = urlQueryInfo?.keyword;
  }
  useEffect(() => {
    if (keywords) handleSearch(keywords);
    else handleSearch('');
  }, [location.pathname]);
  const fetchKeyword = (key, value) => {
    LxSiteClick({ bid: 'b_ead_hdbhkfqj_mc', valLab: { keywords: value } });
    iptRef?.current?.focus();
    let queryInfo = urlParse(location.search);
    if (value) {
      queryInfo = { ...queryInfo, [key]: encodeURIComponent(value) };
    } else {
      delete queryInfo[key];
    }
    delete queryInfo[PAGE_NO];
    replace(pathname, queryInfo);
  };

  return (
    <div className="zp_search">
      <div className="zp_search_input">
        <Input
          autoComplete="off"
          ref={iptRef}
          placeholder="输入关键词搜索岗位"
          maxLength={99}
          clearable={false}
          value={headerStore.keywords}
          dispatchChange={['onInput']}
          onPressEnter={(e) => {
            // @ts-ignore
            fetchKeyword('keyword', e.target.value);
          }}
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
        />
      </div>
      <Button
        className="zp_search_btn"
        type="primary"
        onClick={() => {
          // @ts-ignore
          fetchKeyword('keyword', iptRef.current.value);
        }}
      >
        <i className="iconfont-official-website icon-zp-daodianb-search" style={{ fontSize: 27, color: '#000' }} />
      </Button>
    </div>
  );
});

export default memo(SearchInput);
